import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import { Handle, Position } from 'reactflow'
import Tooltip from '@material-ui/core/Tooltip'
import { AppTheme } from '../../../../styles/AppTheme'
import { HANDLE_DEFAULT } from './chatbotGraph'

function truncate(text, max) {
  const s = String(text || '').trim()
  if (!s) return ''
  if (s.length <= max) return s
  return s.slice(0, max) + '…'
}

function actionButtonIcon(type) {
  const t = String(type || '').toUpperCase()
  if (t === 'URL') return 'open_in_new'
  if (t === 'FLOW') return 'assignment'
  return 'reply'
}

function isDefaultHandle(h) {
  return !!(h && (h.kind === 'default' || h.id === HANDLE_DEFAULT))
}

export function partitionBranchHandles(handles) {
  const options = []
  let fallback = null
  ;(handles || []).forEach(h => {
    if (isDefaultHandle(h)) fallback = h
    else options.push(h)
  })
  return { options, fallback }
}

export function ChatbotDefaultHandle(props) {
  const h = props.handle
  if (!h) return null
  return (
    <Tooltip title='If they type something else' arrow placement='top'>
      <div className={css(Styles.defaultRow)}>
        <i className={'material-icons-outlined ' + css(Styles.defaultIcon)}>alt_route</i>
        <div className={css(Styles.defaultLabel)}>Default</div>
        <Handle
          type='source'
          position={Position.Right}
          id={h.id}
          style={props.handleStyle}
        />
      </div>
    </Tooltip>
  )
}

export function ChatbotBranchHandles(props) {
  const handles = props.handles || []
  const iType = props.interactivityType
  const handleStyle = props.handleStyle
  if (!handles.length) return null
  return (
    <div className={css(Styles.options)}>
      {handles.map(h => (
        <div
          key={h.id}
          className={css(Styles.optionRow, iType === 'LIST' && Styles.optionRowList)}
        >
          {iType !== 'LIST' ? (
            <i className={'material-icons-outlined ' + css(Styles.optionIcon)}>{actionButtonIcon(h.buttonType)}</i>
          ) : null}
          <div className={css(Styles.optionText, iType === 'LIST' && Styles.optionTextList)}>
            <div className={css(Styles.optionTitle, iType === 'LIST' && Styles.optionTitleList)}>
              {truncate(h.label, 28) || 'Option'}
            </div>
            {iType === 'LIST' && h.description ? (
              <div className={css(Styles.optionDesc)}>{truncate(h.description, 40)}</div>
            ) : null}
          </div>
          <Handle
            type='source'
            position={Position.Right}
            id={h.id}
            style={handleStyle}
          />
        </div>
      ))}
    </div>
  )
}

const Styles = StyleSheet.create({
  options: {
    overflow: 'visible',
  },
  optionRow: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    padding: '10px 14px',
    borderTop: '1px solid #d9efce',
    boxSizing: 'border-box',
    overflow: 'visible',
    color: '#027eb5',
  },
  optionRowList: {
    justifyContent: 'flex-start',
    paddingLeft: 12,
    paddingRight: 16,
    color: '#222222',
  },
  optionIcon: {
    fontSize: 16,
    lineHeight: 1,
    color: 'inherit',
  },
  optionText: {
    minWidth: 0,
    textAlign: 'center',
  },
  optionTextList: {
    textAlign: 'left',
    flex: 1,
  },
  optionTitle: {
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 700,
    color: 'inherit',
    wordBreak: 'break-word',
  },
  optionTitleList: {
    color: '#222222',
    fontWeight: 600,
  },
  optionDesc: {
    fontSize: 11,
    lineHeight: '14px',
    color: '#6B7280',
    wordBreak: 'break-word',
    marginTop: 2,
  },
  defaultRow: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    padding: '10px 14px',
    boxSizing: 'border-box',
    overflow: 'visible',
    backgroundColor: AppTheme.secondaryBg,
    borderTop: '1px solid ' + AppTheme.borderColor,
    borderBottomLeftRadius: AppTheme.borderRadius,
    borderBottomRightRadius: AppTheme.borderRadius,
    color: '#6B7280',
  },
  defaultIcon: {
    fontSize: 16,
    lineHeight: 1,
    color: '#6B7280',
  },
  defaultLabel: {
    fontSize: 13,
    lineHeight: '18px',
    fontWeight: 600,
    color: '#6B7280',
  },
})
